/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.analytics.init());

App.analytics = {

  init() {
    return this.set_signup_referrer();
  },

  set_signup_referrer() {
    // Set the signup_referrer cookie only the first time we see them
    // Try to get it from _ts_referrer first, else document.referrer
    if (!Cookies.get('signup_referrer')) {
      const referrer = Cookies.get('_ts_referrer') || document.referrer;
      Cookies.set('signup_referrer', referrer, { expires: 999 });
    }

    // If there is a value in the 'ref' param, set the _ts_campaign cookie to it
    // This 'ref' could come from some adword campaign, or it could be an internal
    // referral e.g. from a Subscribe page
    if (!Cookies.get('_ts_campaign')) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('utm')) {
        return Cookies.set('_ts_campaign', params.get('utm'), { expires: 999 });
      } else if (params.get('ref')) {
        return Cookies.set('_ts_campaign', params.get('ref'), { expires: 999 });
      }
    }
  }
};
